// SCROLL URLS

const page = $("html, body");

$('body').find("a[href*=\"#\"]").on("click touchstart", function (e) {
// $('body').find("a.anchor_link").on("click touchstart", function (e) {

    if (e.type == "touchstart") {
        $(this).off('click');
        // console.log("Only touch event is fired");
    } else if (e.type == "click") {
        $(this).off('touchstart');
        // console.log("Only click event is fired");
    }


    e.preventDefault();

    let hashpos_href = $(this).attr("href").indexOf("#", 0);
    let hashtag_href = $(this).attr("href").slice(hashpos_href + 1)
    let baseurl_href = $(this).attr("href").slice(0, hashpos_href);

    let hashpos_window = window.location.href.indexOf("#", 0)
    let basetarget_window;

    if (hashpos_window > 0) {
        // console.log("current url has hash");
        // console.log("position: " + hashpos_window);
        // console.log("Link URL: " + $(this).attr("href"));
        // console.log("window.location.href:" + window.location.href);
        basetarget_window = window.location.href.slice(0, hashpos_window);
        // console.log("new basetarget:" + basetarget_window);
    } else {
        // console.log("current url has no hash");
        basetarget_window = window.location.href;
        console.log(basetarget_window);
    }

    if (basetarget_window != baseurl_href) {
        window.location = $(this).attr("href");
    } else {

        let scrollposition;

        if ($("#" + hashtag_href + "").length > 0) {
            
            console.log("anchor: "+hashtag_href);
            if(hashtag_href != "kata-agorein-stiftung-1") {
                scrollposition = $("#" + hashtag_href + "").offset().top + 10;
            } else {
                scrollposition = 1;
            }

            page.animate({
                scrollTop: scrollposition
            }, "800", function () {
                page.off("scroll mousedown wheel DOMMouseScroll mousewheel touchmove")
                history.pushState(null, null, "#" + hashtag_href);
            })
        }
    }

});